export const ORGANIZATION_LIST_PAGE_LIMIT = 1_000_000
